import type { ShopStatusDTO } from '@nine80/shared';
import type { Messages } from '../locales/messages';
import type { TFunction } from '../lib/i18n';

function reasonToKey(reasonCode: ShopStatusDTO['reasonCode']): keyof Messages['shopStatus'] {
  switch (reasonCode) {
    case 'OPEN':
      return 'open';
    case 'CLOSED_TODAY':
      return 'closedToday';
    case 'BEFORE_OPEN':
      return 'beforeOpen';
    case 'AFTER_CLOSE':
      return 'afterClose';
    case 'REGISTRATION_CUTOFF':
      return 'registrationCutoff';
    case 'MANUALLY_PAUSED':
      return 'manuallyPaused';
    case 'MANUALLY_CLOSED':
      return 'manuallyClosed';
    default:
      return 'closedToday';
  }
}

export function ShopStatusBadge({ status, t }: { status: ShopStatusDTO; t: TFunction }) {
  const key = reasonToKey(status.reasonCode);
  const label = t(`shopStatus.${key}`);
  const badgeClass = status.acceptingWalkins
    ? 'badge-open'
    : status.open
      ? 'badge-paused'
      : 'badge-closed';

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className={badgeClass}>
        <span className="h-2 w-2 rounded-full bg-current" aria-hidden="true" />
        {label}
      </span>
      {status.open && (
        <span className="text-sm text-fg-muted">
          {status.acceptingWalkins
            ? t('shopStatus.walkInsAvailable')
            : t('shopStatus.walkInsClosed')}
        </span>
      )}
    </div>
  );
}
